window.PROTEIN_COMPARISON_DATA = {
    comparisons: [
        {
            proteinKey: 'whey',
            metrics: {
                EAA: {
                    total: 60,
                    step: 10,
                    blg: 52.8,
                    other: 41.9,
                    diff_percent: 26,
                },
                BCAA: {
                    total: 30,
                    step: 5,
                    blg: 28.2,
                    other: 20.1,
                    diff_percent: 40,
                },
                leucine: {
                    total: 18,
                    step: 3,
                    blg: 15.7,
                    other: 10.8,
                    diff_percent: 45,
                },
            },
        },
        {
            proteinKey: 'casein',
            metrics: {
                EAA: {
                    total: 60,
                    step: 10,
                    blg: 52.8,
                    other: 39.0,
                    diff_percent: 35,
                },
                BCAA: {
                    total: 30,
                    step: 5,
                    blg: 28.2,
                    other: 18.9,
                    diff_percent: 49,
                },
                leucine: {
                    total: 18,
                    step: 3,
                    blg: 15.7,
                    other: 9.3,
                    diff_percent: 69,
                },
            },
        },
        {
            proteinKey: 'pea',
            metrics: {
                EAA: {
                    total: 60,
                    step: 10,
                    blg: 52.8,
                    other: 30.1,
                    diff_percent: 75,
                },
                BCAA: {
                    total: 30,
                    step: 5,
                    blg: 28.2,
                    other: 15.6,
                    diff_percent: 80,
                },
                leucine: {
                    total: 18,
                    step: 3,
                    blg: 15.7,
                    other: 7.8,
                    diff_percent: 101,
                },
            },
        },
        {
            proteinKey: 'soy',
            metrics: {
                EAA: {
                    total: 60,
                    step: 10,
                    blg: 52.8,
                    other: 28.4,
                    diff_percent: 86,
                },
                BCAA: {
                    total: 30,
                    step: 5,
                    blg: 28.2,
                    other: 14.7,
                    diff_percent: 92,
                },
                leucine: {
                    total: 18,
                    step: 3,
                    blg: 15.7,
                    other: 8.1,
                    diff_percent: 91,
                },
            },
        },
        {
            proteinKey: 'collagen',
            metrics: {
                EAA: {
                    total: 60,
                    step: 10,
                    blg: 52.8,
                    other: 7.7,
                    diff_percent: 585,
                },
                BCAA: {
                    total: 30,
                    step: 5,
                    blg: 28.2,
                    other: 5.5,
                    diff_percent: 413,
                },
                leucine: {
                    total: 18,
                    step: 3,
                    blg: 15.7,
                    other: 2.9,
                    diff_percent: 441,
                },
            },
        },
    ],
};

class ProteinComparison extends HTMLElement {
    constructor() {
        super();

        this.state = {
            nutrient: null,
            protein: null,
        };

        this._hasMounted = false;

        this.onNutrientTabChange = this.onNutrientTabChange.bind(this);
        this.onSourceToggle = this.onSourceToggle.bind(this);
        this.onSourceSelect = this.onSourceSelect.bind(this);
        this.onOutsidePointerDown = this.onOutsidePointerDown.bind(this);
    }

    connectedCallback() {
        if (this._initialized) return;
        this._initialized = true;

        /* -------------------- Nutrient tabs (ui-tabs) -------------------- */

        this.nutrientTabs = this.querySelector('ui-tabs');
        const selectedTab = this.nutrientTabs?.querySelector('[role="tab"][aria-selected="true"]');
        this.state.nutrient = selectedTab?.dataset?.value?.trim() || 'leucine';

        this.nutrientTabs?.addEventListener('ui:tabchange', this.onNutrientTabChange);

        /* -------------------- Dropdown -------------------- */

        this.dropdownWrapper = this.querySelector('[role="listbox"]')?.closest('.relative');
        if (!this.dropdownWrapper) return;

        this.sourceButton = this.dropdownWrapper.querySelector('[role="combobox"]');
        this.sourceLabel = this.sourceButton?.querySelector('[data-combobox-label]') || this.sourceButton?.querySelector('span');
        this.listbox = this.dropdownWrapper.querySelector('[role="listbox"]');
        this.options = [...this.dropdownWrapper.querySelectorAll('[role="option"] button')];

        this.state.protein = this.sourceButton?.dataset.value || this.options.find((b) => b.parentElement.getAttribute('aria-selected') === 'true')?.dataset.value || 'whey';

        this.sourceButton?.addEventListener('click', this.onSourceToggle);
        this.options.forEach((opt) => opt.addEventListener('click', this.onSourceSelect));

        document.addEventListener('pointerdown', this.onOutsidePointerDown, true);

        this.update();
    }

    disconnectedCallback() {
        document.removeEventListener('pointerdown', this.onOutsidePointerDown, true);
    }

    /* -------------------- Nutrient tabs -------------------- */

    onNutrientTabChange(e) {
        const value = e.detail?.value;
        if (value == null) return;
        this.state.nutrient = String(value).trim();
        this.update();
    }

    /* -------------------- Dropdown -------------------- */

    onSourceToggle(e) {
        e.stopPropagation();
        const isOpen = this.sourceButton.getAttribute('aria-expanded') === 'true';

        isOpen ? this.closeDropdown() : this.openDropdown();
    }

    // The list fades in and slides down a few pixels when it opens, and fades out the same way when it closes
    // (also after picking an option). Instant for people who prefer reduced motion.
    dropdownCanAnimate() {
        return 'animate' in this.listbox && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    openDropdown() {
        this.sourceButton.setAttribute('aria-expanded', 'true');
        this.finishCloseDropdown();
        this.listbox.hidden = false;
        if (!this.dropdownCanAnimate()) return;
        this.listbox.animate(
            [{ opacity: 0, transform: 'translateY(-4px)' }, { opacity: 1, transform: 'none' }],
            { duration: 200, easing: 'ease-out' }
        );
    }

    closeDropdown(afterHidden) {
        if (this.listbox.hidden) return;
        this.sourceButton.setAttribute('aria-expanded', 'false');
        this.afterDropdownHidden = afterHidden;
        if (!this.dropdownCanAnimate()) {
            this.listbox.hidden = true;
            this.finishCloseDropdown();
            return;
        }
        this.listbox.getAnimations().forEach((a) => a.cancel());
        this.listbox.animate(
            [{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(-4px)' }],
            { duration: 160, easing: 'ease-in', fill: 'forwards' }
        ).onfinish = () => {
            // Opened again in the meantime: leave it open
            if (this.sourceButton.getAttribute('aria-expanded') === 'true') return;
            this.listbox.hidden = true;
            this.finishCloseDropdown();
        };
    }

    // Ends a running close fade and runs what had to wait until the list was gone
    finishCloseDropdown() {
        this.listbox.getAnimations().forEach((a) => a.cancel());
        const afterHidden = this.afterDropdownHidden;
        this.afterDropdownHidden = null;
        afterHidden?.();
    }

    onSourceSelect(e) {
        const optionBtn = e.currentTarget;
        const proteinKey = optionBtn.dataset.value;
        const label = optionBtn.textContent.trim();

        this.sourceButton.dataset.value = proteinKey;
        this.selectedLabel = label;
        this.state.protein = proteinKey;

        // Mark the new option as selected only once the list has faded out, so the tap shows just the tik-state.
        // The "BLG vs ..." label also changes only then: it is centered on mobile, so a longer or shorter name
        // would shift the list while it fades out.
        this.closeDropdown(() => {
            this.sourceLabel.textContent = label;
            this.options.forEach((btn) => btn.parentElement.setAttribute('aria-selected', 'false'));
            optionBtn.parentElement.setAttribute('aria-selected', 'true');
        });
        this.update();
    }

    onOutsidePointerDown(e) {
        if (!this.dropdownWrapper?.contains(e.target)) {
            this.closeDropdown();
        }
    }

    /* -------------------- Core Update -------------------- */

    update() {
        const { nutrient, protein } = this.state;

        if (!nutrient || !protein) {
            return;
        }

        this._hasMounted = true;

        this.handleSelection({ nutrient, protein });
    }

    /* -------------------- Graph Rendering -------------------- */

    handleSelection({ nutrient, protein }) {
        if (!window.PROTEIN_COMPARISON_DATA) {
            return;
        }

        const comparison = window.PROTEIN_COMPARISON_DATA.comparisons.find(
            (c) => c.proteinKey === protein
        );

        if (!comparison) {
            return;
        }

        const metric = comparison.metrics[nutrient];

        if (!metric) {
            return;
        }

        const { total, step, blg, other, diff_percent } = metric;

        this.updateAxis(step);
        this.updateBars(total, blg, other);
        this.updateValues(blg, other);
        this.updateDiff(diff_percent);
        const proteinLabel = this.selectedLabel || this.sourceLabel?.textContent?.trim() || protein;
        this.updateLabels(nutrient, proteinLabel);
    }

    updateAxis(step) {
        const steps = this.querySelectorAll('[data-step]');
        steps.forEach((el, i) => {
            el.textContent = (i * step).toFixed(1);
        });
    }

    updateBars(total, blg, other) {
        const blgBar = this.querySelector('[data-bar="blg"]');
        const otherBar = this.querySelector('[data-bar="other"]');
        const diffLine = this.querySelector('[data-diff-line]');

        const blgWidth = (blg / total) * 100;
        const otherWidth = (other / total) * 100;

        this.animationDuration = 1.5;
        this.animationEase = 'expo.inOut';

        gsap.to(blgBar, {
            width: `${blgWidth}%`,
            duration: this.animationDuration,
            ease: 'expo.inOut',
        });

        gsap.to(otherBar, {
            width: `${otherWidth}%`,
            duration: this.animationDuration,
            ease: this.animationEase,
        });

        if (diffLine) {
            gsap.to(diffLine, {
                left: `${blgWidth}%`,
                duration: this.animationDuration,
                ease: this.animationEase,
            });
        }
    }

    updateValues(blg, other) {
        const blgEl = this.querySelector('[data-value="blg"]');
        const otherEl = this.querySelector('[data-value="other"]');
        if (!blgEl || !otherEl) return;

        const currentBlg = parseFloat(blgEl.textContent.replace(/[^\d.-]/g, '')) || 0;
        const currentOther = parseFloat(otherEl.textContent.replace(/[^\d.-]/g, '')) || 0;

        gsap.to(
            { value: currentBlg },
            {
                value: blg,
                duration: this.animationDuration,
                ease: this.animationEase,
                onUpdate: function () {
                    blgEl.textContent = `${this.targets()[0].value.toFixed(1)}%`;
                },
            }
        );

        gsap.to(
            { value: currentOther },
            {
                value: other,
                duration: this.animationDuration,
                ease: this.animationEase,
                onUpdate: function () {
                    otherEl.textContent = `${this.targets()[0].value.toFixed(1)}%`;
                },
            }
        );
    }

    updateDiff(diff) {
        const diffEl = this.querySelector('[data-diff-value]');
        if (!diffEl) return;

        const current = parseFloat(diffEl.textContent.replace(/[^\d.-]/g, '')) || 0;

        gsap.to(
            { value: current },
            {
                value: diff,
                duration: this.animationDuration,
                ease: this.animationEase,
                onUpdate: function () {
                    diffEl.textContent = `+${Math.round(this.targets()[0].value)}%`;
                },
            }
        );
    }

    updateLabels(nutrient, proteinLabel) {
        const axisTitle = this.querySelector('[data-axis-title="nutrient_type"]');
        const otherLabel = this.querySelector('[data-label="other"]');
        const activeTab = this.nutrientTabs?.querySelector(`[role="tab"][data-value="${nutrient}"]`);
        const nutrientLabel = activeTab?.textContent?.trim() || nutrient;

        if (axisTitle) axisTitle.textContent = nutrientLabel;
        if (otherLabel) otherLabel.textContent = proteinLabel;
    }
}

customElements.define('protein-comparison', ProteinComparison);

